var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"background"},[_c('video',{attrs:{"autoplay":"","loop":"","id":"video-background","muted":"","plays-inline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.video.src,"type":_vm.video.type}})])]),_c('div',{staticClass:"content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }